export const bicBank = {
  ABNAFRPP: 'THE ROYAL BANK OF SCOTLAND PLC PARIS BRANCH',
  AECFFR21: 'AMERICAN EXPRESS CARTE FRANCE',
  AFRIFRPP: 'BOA- FRANCE',
  AGFBFRCC: 'ALLIANZ BANQUE S.A. (former BANQUE AGF S.A.)',
  AGRIFRPI: 'AMUNDI ASSET MANAGEMENT',
  AGRIFRPP: 'CREDIT AGRICOLE',
  AGRIMQMX: 'CRCAM DE LA MARTINIQUE ET DE LA GUYANE',
  AGRIRERX: 'CRCAM DE LA REUNION',
  ARCEFRP1: 'ARCALIS ACTIF GENERAL LA POSTE',
  AUDIFRPP: 'BANK AUDI FRANCE',
  AXABFRPP: 'AXA BANQUE SA',
  BAMYFR22: 'BANQUE MICHEL INCHAUSPE BAMI',
  BARCFRPP: 'BARCLAYS BANK PLC',
  BATIFRP1: 'BANQUE DU BAT ET DES TRAV PUB BTP BANQUE',
  BBPIFRPP: 'BANCO BPI',
  BCDMFRPP: 'BANQUE CHAABI DU MAROC',
  BCHAFR21: 'BANQUE CHALUS',
  BCITFRPP: 'INTESA SANPAOLO SPA Succursale de Paris',
  BCMAFRPP: 'ATTIJARIWAFA BANK(FORMERLY BANQUE COMMERCIALE DU MAROC)',
  BCRTFRP1: 'CORTAL CONSORS',
  BCRTFRPP: 'CORTAL CONSORS',
  BDEIFRPP: "BANQUE THEMIS(FORMERLY BANQUE DE L'ILE DE FRANCE - B.D.E.I.)",
  BDFEFR2L: 'BANQUE DE FRANCE',
  BDFEFR2T: 'BANQUE DE FRANCE',
  BDFEFRPP: 'BANQUE DE FRANCE',
  BDUPFR2S: 'BANQUE DUPUY DE PARSEVAL',
  BEPOFR21: 'BANCA POPOLARE DI BERGAMO - CREDITO VARESINO',
  BFBKFRP1: 'BFORBANK',
  BGFIFRPP: 'BGFI INTERNATIONAL',
  BIKCFRP1: 'BINCKBANK',
  BMCEFRPP: 'BMCE BANK INTERNATIONAL PLC SUCCURSALE EN FRANCE',
  BMMMFR2A: 'BANQUE MARTIN - MAUREL',
  BMRZFR21: 'BANQUE MARZE',
  BNABFRPP: 'BNP PARIBAS ARBITRAGE SNC',
  BNPAFRPH: 'BNP PARIBAS SA(FORMERLY BANQUE NATIONALE DE PARIS S.A.)',
  BNPAFRPP: 'BNP PARIBAS',
  BNPAGFGX: 'BNP PARIBAS GUYANE',
  BNPARERX: 'BNP PARIBAS REUNION',
  BNPCFR21: 'BNP PARIBAS FACTOR',
  BNUGFR21: 'BANQUE NUGER',
  BOFAFRPP: 'BANK OF AMERICA, N.A.PARIS BRANCH',
  BOTKFRPX: 'The Bank of Tokyo - Mitsubishi UFJ, Ltd.',
  BOUSFRPP: 'BOURSORAMA',
  BPCEFRPP: 'BPCE SA',
  BPFIFRP1: 'LA BANQUE POSTALE FINANCEMENT',
  BPNPFRP1: 'BPN - BANCO PORTUGUES DE NEGOCIOS SA',
  BPOLPFTP: 'BANQUE DE POLYNESIE',
  BPPBFRP1: 'BNP PARIBAS PRIVATE BANK',
  BPSMFRPP: 'BANQUE BCP',
  BRASFRPP: 'BANCO DO BRASIL AG SUCCURSALE FRANCE',
  BREDFRPP: 'BRED BANQUE POPULAIRE',
  BSAVFR2C: 'BANQUE DE SAVOIE',
  BSPFFRPP: 'BANQUE PALATINE',
  BSUIFRPP: 'CREDIT AGRICOLE CIB',
  CAONFR21: 'CAPITAL ONE',
  CCBPFRPP: 'BANQUE POPULAIRE',
  CCFEFRP1: 'CCM FDS DU REGIME CC PF',
  CCFRFRCR: 'HSBC FRANCE',
  CCFRFRPP: 'HSBC FRANCE',
  CCMOFR21: 'CAISSE DE CREDIT MUNICIPAL DE BORDEAUX',
  CCMVFR21: 'CAISSE DE CREDIT MUTUEL LAVAL BRETAGNE',
  CCOPFRCP: 'Credit Cooperatif Societe Cooperative',
  CCOPFRPP: 'CREDIT COOPERATIF',
  CCUTFR21: 'CSSE CIT MUNICIPAL DE TOULON',
  CDCGFRPP: 'CAISSE DES DEPOTS ET CONSIGNATIONS',
  CDPRFRP1: 'CDC PROJETS',
  CEPAFRPP: "CAISSE D'EPARGNE PROVENCE ALPES CORSE",
  CEPANCNM: 'BANQUE DE NOUVELLE CALEDONIE',
  CFCUFR21: 'CAISSE FEDERALE DE CREDIT MUTUELLE NORMANDIE',
  CFFIFR2L: 'COFIDIS',
  CFFRFRPP: 'CREDIT FONCIER DE FRANCE',
  CGCPFRP1: 'COMPAGNIE GENERALE DE CREDIT AUX PARTICULIERS - CREDIPAR',
  CGDIFRPP: 'CAIXA GERAL DE DEPOSITOS S A',
  CGRCFRP1: 'CAISSE GENERALE RETRAITE CAISSE D EPARGNE',
  CHASFRPB: 'JPMORGAN CHASE BANK, N.A.',
  CHASFRPP: 'JPMORGAN CHASE BANK, N.A.',
  CITIFRPP: 'CITIBANK INTERNATIONAL LIMITED FRANCE BRANCH',
  CLBQFRP1: 'CLF BANQUE',
  CMBRFR2B: 'CREDIT MUTUEL ARKEA',
  CMCIFR21: 'CREDIT MUTUEL - CIC BANQUES',
  CMCIFR2A: 'CAISSE FEDERALE DE CREDIT MUTUEL',
  CMCIFRP1: 'CREDIT MUTUEL - CIC BANQUES',
  CMCIFRPA: 'CREDIT MUTUEL - CIC BANQUES',
  CMCIFRPB: 'CM CIC SECURITIES',
  CMCIFRPP: 'CREDIT INDUSTRIEL ET COMMERCIAL CIC',
  CMDIFR21: 'CREDIT MUNICIPAL DE DIJON',
  CMMMFR21: 'CRC MARIT MUT DE LA MEDITERRANEE',
  CMUTFR21: 'CAISSE FEDERALE DU CREDIT MUTUEL DE LOIRE ATLANTIQUE ET DU CENTRE OUEST',
  COBAFRPX: 'COMMERZBANK AG',
  CONOFRP1: 'COFINOGA',
  COUOFR21: 'COFIROUTE',
  COURFR2T: 'BANQUE COURTOIS',
  CPMEFRPP: 'BPIFRANCE',
  CRAFFRP1: 'CREALFI',
  CRGEFR2X: 'BANCA CARIGE SPA',
  CRLYFRPP: 'CREDIT LYONNAIS',
  CRTAFR21: 'CREATIS',
  DELUFR22: 'BANQUE DELUBAC ET CIE',
  DEUTFRPP: 'DEUTSCHE BANK AG',
  ECOCFRPP: 'EBI SA',
  EDFGFRPP: 'ELECTRICITE DE FRANCE',
  ELFAFRP1: 'HSBC FACTORING FRANCE',
  FACFFRPP: 'GE FACTOFRANCE',
  FAMSFRPP: 'BNPPARIBAS FINAMS',
  FEMBFRP1: 'BANQUE FRANCAISE MUTUALISTE',
  FIDCFR21: 'BANQUE FIDUCIAL',
  FPELFR21: 'FINANCIERE DES PAIEMENTS ELECTRONIQUES S.A.S.',
  FTELFRPP: 'ORANGE SA',
  FTNOFRP1: 'FORTUNEO',
  GPBAFRPP: 'GROUPAMA BANQUE',
  GSCFFR22: 'SOCIETE GENERALE SCF',
  GSFHFRPP: 'SOCIETE GENERALE SFH',
  GSZGFRPP: 'GDF SUEZ',
  HCREFR21: 'HERVET CREDITERME',
  IIDFFR21: 'ING DIRECT NV',
  INGBFRPP: 'ING BANK France',
  ISAEFRPP: 'CACEIS BANK FRANCE',
  KOEXFRPP: 'KOREA EXCHANGE BANK',
  KOLBFR21: 'BANQUE KOLB S.A.',
  KREDFRPP: 'KBC BANK NV PARIS',
  LAYDFR2W: 'BANQUE LAYDERNIER',
  LCLPFRP1: 'LCL BANQUE PRIVEE',
  LEGRFRP1: 'LEGAL AND GENERAL BANK(FRANCE)',
  MCCFFRP1: 'MACIF - MUTUALITE',
  MIDLFRCP: 'HSBC BANK PLC',
  MIDLFRPX: 'HSBC BANK PLC',
  MONTFRPP: 'MONTE PASCHI BANQUE S A',
  NATXFRPP: 'Natixis SA',
  NFACFR21: 'NATIXIS FACTOR',
  NORDFRPP: 'CREDIT DU NORD',
  NSMBFRPP: 'BANQUE NEUFLIZE OBC',
  ODDOFRPP: 'ODDO ET CIE',
  ODYVFRP1: 'ODYSSEE VENTURE',
  OPSPFR21: 'OLKY PAYMENT SERVICE PROVIDER',
  PARBFRPP: 'BNP PARIBAS SECURITIES SERVICES',
  PAREFRPP: 'SOCIETE DE BOURSE PAREL',
  POUYFR21: 'BANQUE POUYANNE',
  PREUFRP1: 'BPE',
  PSABFRPP: 'BANQUE PSA FINANCE',
  PSSTFRPP: 'LA BANQUE POSTALE',
  RALPFR2G: 'BANQUE RHONE ALPES',
  REUBRERX: 'BANQUE DE LA REUNION',
  RGFIFRPP: 'BANQUE DE REALISATIONS DE GESTION ET DE FINANCEMENT',
  RGFPFRP1: 'RECETTE GENERALE DES FINANCES DE PARIS',
  SBEXFRP1: 'STE DE BANQUE ET D EXPANSION SBE(2EME)',
  SBINFRPP: 'STATE BANK OF INDIA',
  SFBSFRP1: 'SOFIB',
  SICVFRPP: 'EUROCLEAR FRANCE',
  SLMPFRP1: 'SLIMPAY',
  SMCTFR2A: 'STE MARSEILLAISE DE CREDIT',
  SOAPFR22: 'CARREFOUR BANQUE',
  SOCBPFTX: 'BANQUE SOCREDO',
  SOGEFRPP: 'STE GENERALE',
  SOGEGPGP: 'STE GENERALE DE BANQUE AUX ANTILLES',
  SOGENCNN: 'STE GENERALE CALEDONIENNE DE BQ S G C B',
  SORMFR2N: 'SOCRAM BANQUE',
  TARNFR2L: 'BANQUE TARNEAUD',
  TRGLFRP1: "TRESORERIE GENERALE POUR L'ETRANGER",
  TRPUFRP1: 'TRESOR PUBLIC',
  UBAFFRPP: 'UNION DES BANQUES ARABES ET FRANCAISES - UBAF',
  USINFRPP: 'ARCELORMITTAL TREASURY',
  YROCFRPP: 'YVES ROCHE',
} as const;

export const bicCountriesPatterns: Record<string, string[]> = {
  FR: ['TRZOFR21'],
  DE: ['TRZODEB2'],
  IT: ['TRZOITM2'],
  ES: ['TRZOESM2'],
} as const;
